import { render } from "./PrivacyModal.vue?vue&type=template&id=8d283082"
import script from "./PrivacyModal.vue?vue&type=script&lang=js"
export * from "./PrivacyModal.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./PrivacyModal.vue?vue&type=style&index=0&id=8d283082&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__